import { render, staticRenderFns } from "./BookShelvesManage.vue?vue&type=template&id=0cbfd5e8&scoped=true"
import script from "./BookShelvesManage.vue?vue&type=script&lang=js"
export * from "./BookShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbfd5e8",
  null
  
)

export default component.exports